'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var msaByAlias = exports.msaByAlias = function msaByAlias(msas, alias) {
  return (msas || []).filter(function (msa) {
    return msa.alias === alias;
  })[0];
};
var msaById = exports.msaById = function msaById(msas, id) {
  return (msas || []).filter(function (msa) {
    return msa.id === id;
  })[0];
};
var msaByIdentifier = exports.msaByIdentifier = function msaByIdentifier(msas, identifier) {
  return typeof identifier === 'number' ? msaById(msas, identifier) : msaByAlias(msas, identifier) || msaById(msas, parseInt(identifier, 10));
};